import React from 'react'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import PropTypes from 'prop-types'

// Components
import { If, Text, Page } from '../../../..'
import { OverlayQuestionsFooter } from '../../../Routing'

// Constants
import { QUESTIONS } from '../../../../../constants/messages'
import { PRINCIPAL_PAYMENTS_TOPIC_KEY } from '../../../../../constants/topicKeys'

// Styles
import styles from './ShowInfoPanel.module.scss'

const propTypes = {
  withCurrentHomeData: PropTypes.bool,
}

const questionMessages = defineMessages({
  interestCardRefinance: {
    id: 'Questions.interest.vsRefinance',
    defaultMessage: 'What are the trade-offs versus refinancing?',
  },
  interestCardLargePayment: {
    id: 'Questions.interest.singleLargePayment',
    defaultMessage: 'What if I made a single large payment?',
  },
})

const ShowInfo = ({ withCurrentHomeData }) => {
  const intl = useIntl()

  return (
    <Page>
      <Page.Body className={styles.body}>
        <Text
          size='xl'
          className={styles.heading}
          variant='neutralCool'
          variantCount='900'
        >
          <FormattedMessage
            id='Homeowner.interest.info.headline'
            defaultMessage='Paying extra is an easy way to save'
          />
        </Text>
        <Text
          size='m'
          variant='neutralCool'
          variantCount='700'
          className={styles.subHeader}
        >
          <FormattedMessage
            id='Homeowner.interest.info.content1'
            defaultMessage="If you are able to pay a little extra to your principal each month, it&rsquo;ll cut down significantly on how much interest you pay in the long run. The best part is that there's no paperwork, fees or headaches."
          />
        </Text>
        <Text size='m' variant='neutralCool' variantCount='700'>
          <FormattedMessage
            id='Homeowner.interest.info.content2'
            defaultMessage='You just pay the extra amount you want onto your principal (not into your escrow).'
          />
        </Text>
        <Page.Disclaimer />
      </Page.Body>
      <If condition={withCurrentHomeData}>
        <Page.Footer>
          <OverlayQuestionsFooter
            topic={intl.formatMessage(QUESTIONS.interestCardTopic)}
            topicKey={PRINCIPAL_PAYMENTS_TOPIC_KEY}
            questions={Object.values(questionMessages)}
            placeholder
          />
        </Page.Footer>
      </If>
    </Page>
  )
}

ShowInfo.propTypes = propTypes

export default ShowInfo
